module.exports = __webpack_public_path__ + "static/media/downloadOnAppStore@3x.453e7e93.png";